const ARCHIVE_AUDIT_KEY = 'vehicle-archive-edit-audit-v1';
export const appendArchiveAudit = (payload = {}) => {
    try {
        const raw = localStorage.getItem(ARCHIVE_AUDIT_KEY);
        const rows = raw ? JSON.parse(raw) : [];
        const entry = {
            timestamp: new Date().toISOString(),
            action: payload.action || 'archive_edit',
            actionLabel: payload.actionLabel || 'تعديل من الأرشيف',
            vehicleId: payload.vehicleId || '',
            plateNumber: payload.plateNumber || '',
            fileNumber: payload.fileNumber || '',
            details: payload.details || {},
            timeLabel: new Date().toLocaleString('ar-SA'),
        };
        const next = [entry, ...(Array.isArray(rows) ? rows : [])].slice(0, 120);
        localStorage.setItem(ARCHIVE_AUDIT_KEY, JSON.stringify(next));
    }
    catch (e) {
        console.warn('archive_audit_storage_failed', e);
    }
};
// --- Helper Components ---
export const pickEntityName = (row) => {
    if (!row || typeof row !== 'object')
        return '';
    return (row.name ||
        row.fullName ||
        row.customerName ||
        row.customer_name ||
        row.supplierName ||
        row.supplier_name ||
        row.title ||
        '')
        .toString()
        .trim();
};
export const normalizePartyCatalog = (rows = [], entityPrefix = 'entity') => {
    if (!Array.isArray(rows))
        return [];
    const seen = new Set();
    const normalized = [];
    rows.forEach((row, index) => {
        const name = pickEntityName(row);
        if (!name)
            return;
        const normalizedKey = name.toLowerCase();
        if (seen.has(normalizedKey))
            return;
        seen.add(normalizedKey);
        normalized.push({
            ...row,
            id: row?.id || row?._id || `${entityPrefix}-${index}-${normalizedKey}`,
            name,
        });
    });
    return normalized;
};
export const extractJournalTag = (text = '', tag = '') => {
    if (!tag)
        return '';
    const match = String(text || '').match(new RegExp(`\\[${tag}:([^\\]]+)\\]`, 'i'));
    return String(match?.[1] || '').trim();
};
export const stripJournalTags = (text = '') => String(text || '')
    .replace(/\[PARTY:[^\]]+\]/gi, '')
    .replace(/\[PARTY_TYPE:[^\]]+\]/gi, '')
    .replace(/\[VEHICLE_REF:[^\]]+\]/gi, '')
    .replace(/\[VISIT:[^\]]+\]/gi, '')
    .replace(/\s{2,}/g, ' ')
    .trim();
const RAKAN_SUPPLIER_NAMES = new Set(['راكان', 'rakan', 'Rakan', 'RAKAN']);
export const isRakanSupplierName = (value) => {
    const v = String(value || '').trim();
    if (!v)
        return false;
    if (RAKAN_SUPPLIER_NAMES.has(v))
        return true;
    return v.includes('راكان') || v.toLowerCase().includes('rakan');
};
const ABU_KHALED_NAMES = new Set(['أبو خالد الكبير', 'ابو خالد الكبير', 'أبو خالد', 'ابو خالد']);
export const isAbuKhaledSupplier = (value) => {
    const v = String(value || '').trim();
    if (!v)
        return false;
    if (ABU_KHALED_NAMES.has(v))
        return true;
    return v.includes('أبو خالد الكبير') || v.includes('ابو خالد الكبير');
};
